<template>
  <el-dialog
    :title="$t('xinzeng')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closedialog"
    @open="open"
    :before-close="handleClose"
  >
    <el-form
      ref="addref"
      :model="addform"
      :rules="formrules"
      label-width="120px"
    >
      <el-form-item :label="$t('cp.cpmc')" prop="title">
        <el-input v-model="addform.title"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.cplx')" prop="productid">
        <el-select v-model="addform.productid" :placeholder="$t('qxz')">
          <el-option
            v-for="item in product"
            :key="item.id"
            :label="item.product_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('cp.zwjj')" prop="cndesc">
        <el-input v-model="addform.cndesc"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.ywjj')" prop="endesc">
        <el-input v-model="addform.endesc"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.fxsj')" prop="publishtime">
        <el-date-picker
          v-model="addform.publishtime"
          type="date"
          :placeholder="$t('qxz')"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.fxsl')" prop="publishnum">
        <el-input v-model="addform.publishnum"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.fkbdfw')" required>
        <el-input v-model="addform.mix">
          <template slot="prepend">{{ $t('cp.zxz') }}</template>
        </el-input>
        <el-input v-model="addform.max">
          <template slot="prepend">{{ $t('cp.zdz') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.sjbdfw')" prop="rand">
        <el-input v-model="addform.rand"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.cpdm')" prop="productcode">
        <el-input v-model="addform.productcode"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.suoxie')" prop="abbr">
        <el-input v-model="addform.abbr"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.ysdm')" prop="colorcode">
        <el-input v-model="addform.colorcode"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.sjwfjg')" prop="times">
        <el-input v-model="addform.times"></el-input>
        <el-alert :title="$t('cp.sjtips')" type="error" :closable="false">
        </el-alert>
      </el-form-item>
      <el-form-item :label="$t('cp.zdtzje')" prop="minimum">
        <el-input v-model="addform.minimum"></el-input>
        <el-alert :title="$t('cp.zdtips')" type="error" :closable="false">
        </el-alert>
      </el-form-item>
      <el-form-item :label="$t('cp.zgtzje')" prop="maximum">
        <el-input v-model="addform.maximum"></el-input>
        <el-alert :title="$t('cp.zgtips')" type="error" :closable="false">
        </el-alert>
      </el-form-item>
      <el-form-item :label="$t('cp.ykbl')" prop="ratio">
        <el-input v-model="addform.ratio"></el-input>
        <el-alert :title="$t('cp.yktips')" type="error" :closable="false">
        </el-alert>
      </el-form-item>
      <el-form-item :label="$t('cp.zhouyi')" prop="monday">
        <el-time-picker
          is-range
          v-model="addform.monday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhouer')" prop="tuesday">
        <el-time-picker
          is-range
          v-model="addform.tuesday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhousan')" prop="wednesday">
        <el-time-picker
          is-range
          v-model="addform.wednesday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhousi')" prop="thursday">
        <el-time-picker
          is-range
          v-model="addform.thursday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhouwu')" prop="friday">
        <el-time-picker
          is-range
          v-model="addform.friday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhouliu')" prop="saturday">
        <el-time-picker
          is-range
          v-model="addform.saturday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('cp.zhouri')" prop="sunday">
        <el-time-picker
          is-range
          v-model="addform.sunday"
          range-separator="—"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item :label="$t('bizhong') + '(from)'" prop="from">
        <el-input v-model="addform.from"></el-input>
      </el-form-item>
      <el-form-item :label="$t('bizhong') + '(to)'" prop="to">
        <el-input v-model="addform.to"></el-input>
      </el-form-item>
      <el-form-item :label="$t('cp.sfxs')" prop="isshow">
        <el-radio-group v-model="addform.isshow">
          <el-radio label="1">{{ $t('shi') }}</el-radio>
          <el-radio label="0">{{ $t('fou') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('beizhu')" prop="remark">
        <el-input v-model="addform.remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">{{ $t('tijiao') }}</el-button>
      <el-button @click="handleClose">{{ $t('quxiao') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      product: [],
      addform: {
        title: '',
        productid: '',
        cndesc: '',
        endesc: '',
        publishtime: '',
        publishnum: '',
        mix: '',
        max: '',
        rand: '',
        productcode: '',
        abbr: '',
        colorcode: '',
        times: '',
        minimum: '',
        maximum: '',
        ratio: '',
        monday: ['00:00:00', '23:59:59'],
        tuesday: ['00:00:00', '23:59:59'],
        wednesday: ['00:00:00', '23:59:59'],
        thursday: ['00:00:00', '23:59:59'],
        friday: ['00:00:00', '23:59:59'],
        saturday: ['00:00:00', '23:59:59'],
        sunday: ['00:00:00', '23:59:59'],
        from: '',
        to: '',
        isshow: '1',
        remark: ''
      },
      // 表单验证对象
      formrules: {
        title: [{ required: true, message: '请填写产品名称', trigger: 'blur' }],
        productid: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ],
        cndesc: [
          { required: true, message: '请填写中文简介', trigger: 'blur' }
        ],
        endesc: [
          { required: true, message: '请填写英文简介', trigger: 'blur' }
        ],
        publishtime: [
          { required: true, message: '请填写发行时间', trigger: 'blur' }
        ],
        publishnum: [
          { required: true, message: '请填写发行数量', trigger: 'blur' }
        ],
        rand: [
          { required: true, message: '请填写随机波动范围', trigger: 'blur' }
        ],
        productcode: [
          { required: true, message: '请填写产品代码', trigger: 'blur' }
        ],
        abbr: [{ required: true, message: '请填写缩写', trigger: 'blur' }],
        colorcode: [
          { required: true, message: '请填写颜色代码', trigger: 'blur' }
        ],
        times: [
          { required: true, message: '请填写时间玩法间隔', trigger: 'blur' }
        ],
        minimum: [
          { required: true, message: '请填写最低投注金额', trigger: 'blur' }
        ],
        maximum: [
          { required: true, message: '请填写最高投注金额', trigger: 'blur' }
        ],
        ratio: [{ required: true, message: '请填写盈亏比例', trigger: 'blur' }],
        mondy: [{ required: true, message: '请填写周一时间', trigger: 'blur' }],
        tuesday: [
          { required: true, message: '请填写周二时间', trigger: 'blur' }
        ],
        wednesday: [
          { required: true, message: '请填写周三时间', trigger: 'blur' }
        ],
        thursday: [
          { required: true, message: '请填写周四时间', trigger: 'blur' }
        ],
        friday: [
          { required: true, message: '请填写周五时间', trigger: 'blur' }
        ],
        saturday: [
          { required: true, message: '请填写周六时间', trigger: 'blur' }
        ],
        sunday: [{ required: true, message: '请填写周日时间', trigger: 'blur' }]
      }
    }
  },
  props: ['visible'],
  methods: {
    // 关闭弹窗前操作
    handleClose() {
      this.$emit('close')
    },
    // 打开弹窗
    async open() {
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255,255, 255, 0.7)',
        target: document.querySelector('.el-dialog__body')
      })
      // 请求产品分类数据
      const { data } = await this.$http.get('/admin/product/addproduct')
      if (data) {
        if (data.code === 200) {
          this.product = data.data.product
        } else {
          this.$message.error(data.msg)
        }
      }
      loading.close()
    },
    // 关闭弹窗
    closedialog() {
      this.$refs.addref.resetFields()
    },
    // 提交操作
    submit() {
      this.$refs.addref.validate(async valid => {
        if (!valid) return false
        const { data } = await this.$http.post(
          '/admin/product/addproduct',
          this.addform
        )
        if (data) {
          if (data.code === 200) {
            this.$message.success('操作成功')
            this.handleClose()
            this.$emit('update')
          } else {
            this.$message.error(data.msg)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.el-alert {
  margin-top: 10px;
}
/*表单项宽度自适应  */
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 350px;
}
.el-date-editor.el-input,
.el-select > .el-input,
.el-date-editor.el-input__inner {
  width: 350px;
}
.el-form-item__content .el-input-group {
  width: 50%;
}
.mobile .el-form-item__content .el-input-group {
  width: 100%;
}
.mobile .el-date-editor--daterange.el-input,
.mobile .el-date-editor--daterange.el-input__inner,
.mobile .el-date-editor--timerange.el-input,
.mobile .el-date-editor--timerange.el-input__inner {
  width: 100%;
}
.mobile .el-date-editor.el-input,
.mobile .el-select > .el-input,
.mobile .el-date-editor.el-input__inner {
  width: 100%;
}
</style>
